var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "rect-wrapper"
  }, [_c("div", {
    staticClass: "rect-item rect1"
  }), _c("div", {
    staticClass: "rect-item rect2"
  }), _c("div", {
    staticClass: "rect-item rect3"
  }), _c("div", {
    staticClass: "rect-item rect4"
  }), _c("div", {
    staticClass: "rect-item rect5"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };